import { render } from "./ProfileDetails.vue?vue&type=template&id=de3b1e0c&scoped=true"
import script from "./ProfileDetails.vue?vue&type=script&lang=js"
export * from "./ProfileDetails.vue?vue&type=script&lang=js"

import "./ProfileDetails.vue?vue&type=style&index=0&id=de3b1e0c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de3b1e0c"]])

export default __exports__